/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Warning_Arms_CloseInputs */

const en_us2_body_assessment_warning_arms_close = /** @type {(inputs: Body_Assessment_Warning_Arms_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your arms were close to your trunk, so the waist may be overestimated. Next time, hold them away from your body in an A.`)
};

const pt_br2_body_assessment_warning_arms_close = /** @type {(inputs: Body_Assessment_Warning_Arms_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os braços ficaram perto do tronco, então a cintura pode estar superestimada. Na próxima vez, afaste os braços do corpo em forma de A.`)
};

const es_419_body_assessment_warning_arms_close = /** @type {(inputs: Body_Assessment_Warning_Arms_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus brazos estaban cerca del tronco, así que la cintura puede estar sobrestimada. La próxima vez, sepáralos del cuerpo en forma de A.`)
};

const pt_pt2_body_assessment_warning_arms_close = /** @type {(inputs: Body_Assessment_Warning_Arms_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os braços ficaram perto do tronco, por isso a cintura pode estar sobrestimada. Da próxima vez, afasta os braços do corpo em forma de A.`)
};

const fr_fr2_body_assessment_warning_arms_close = /** @type {(inputs: Body_Assessment_Warning_Arms_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes bras étaient proches du tronc, le tour de taille est peut-être surestimé. La prochaine fois, écarte-les du corps en A.`)
};

const de_de2_body_assessment_warning_arms_close = /** @type {(inputs: Body_Assessment_Warning_Arms_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Arme waren nah am Rumpf, daher wird die Taille eventuell überschätzt. Halte sie nächstes Mal in A-Form vom Körper weg.`)
};

const it_it2_body_assessment_warning_arms_close = /** @type {(inputs: Body_Assessment_Warning_Arms_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le braccia erano vicine al tronco, quindi la vita potrebbe essere sovrastimata. La prossima volta, tienile staccate dal corpo ad A.`)
};

/**
* | output |
* | --- |
* | "Your arms were close to your trunk, so the waist may be overestimated. Next time, hold them away from your body in an A." |
*
* @param {Body_Assessment_Warning_Arms_CloseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_warning_arms_close = /** @type {((inputs?: Body_Assessment_Warning_Arms_CloseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Warning_Arms_CloseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_warning_arms_close(inputs)
	if (locale === "es-419") return es_419_body_assessment_warning_arms_close(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_warning_arms_close(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_warning_arms_close(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_warning_arms_close(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_warning_arms_close(inputs)
	return en_us2_body_assessment_warning_arms_close(inputs)
});
export { body_assessment_warning_arms_close as "body-assessment.warning.arms_close" }